import type { PostPutBrandTranslationAdminEntity } from './PostPutBrandTranslationAdminEntity'

export class CreateUpdateBrandEntity {
  translations?: Array<PostPutBrandTranslationAdminEntity>
  profileImage?: { bytes: string; fileName: string }
  coverImage?: { bytes: string; fileName: string }
  imageUrl?: string
  distanceCapInKm?: number | null
}
